import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Feed from "./feed";

class FeedClient {
  constructor(instance) {
    _defineProperty(this, "instance", void 0);

    this.instance = instance;
  }

  initialize(feedChannelId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Feed(this.instance, feedChannelId, options);
  }

}

export { Feed };
export default FeedClient;
//# sourceMappingURL=index.js.map